import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "../src/components/auth/Login";
import Rootrouter from "./pages/Rootrouter";
import Chat from "./pages/Chat";
import Adminwelcom from "./pages/Adminwelcom";
import Adminroot from "./pages/Adminroot";
import Adminchats from "./components/admin/Adminchats";
import Adminpermission from "./components/admin/Adminpermission";
import Addchat from "./components/admin/Addchat";
import Adduser from "./components/admin/Adduser";
import Thechat from "./components/admin/Thechat";
import Protectedroute from "./pages/Protectedroute";
import Onlyadmin from "./components/admin/Onlyadmin";
import Finishedchats from "./components/admin/Finishedchats";
import Messages from "./components/chat/Messages";
import Onlysupervisor from "./components/admin/Onlysupervisor";
import Onlysupport from "./components/admin/Onlysupport";
import Chatpermission from "./components/admin/Chatpermission";
// import { getToken } from "firebase/messaging";
import { getTokenB, onMessageListener } from "./firebase/config";
import { toast } from "react-toastify";
import Signup from "./components/auth/Signup";
import ResetPassword from "./components/auth/ResetPassword";
const router = createBrowserRouter([
  {
    path: "/",
    element: <Rootrouter />,
    children: [
      { index: true, element: <Login /> },
      {
        path: "signup",
        element: (
         <Signup/>
        ),
      },
      {
        path: "reset",
        element: (
         <ResetPassword/>
        ),
      },
      {
        path: "admin",
        element: (
          <Onlyadmin>
            <Adminwelcom />
          </Onlyadmin>
        ),
      },
    ],
  },
  {
    path: "/chat",
    element: (
      <Protectedroute>
        <Chat />
      </Protectedroute>
    ),
    children: [
      {
        index: true,
        element: (
          <Protectedroute>
            <Messages />
          </Protectedroute>
        ),
      },
      {
        path: "messages",
        element: (
          <Protectedroute>
            <Messages />
          </Protectedroute>
        ),
      },
      {
        path: "adminpermission",
        element: (
          <Onlysupervisor>
            <Adminpermission />
          </Onlysupervisor>
        ),
      },
      {
        path: "adminchats",
        element: (
          <Onlysupport>
            <Adminchats support={true} />
          </Onlysupport>
        ),
      },
      {
        path: "chatpermission",
        element: (
          <Onlysupervisor>
            <Chatpermission support={true} />
          </Onlysupervisor>
        ),
      },
    ],
  },
  {
    path: "dashboard",
    element: <Adminroot />,
    children: [
      {
        index: true,
        element: (
          <Onlyadmin>
            <Adminchats permission={false} />
          </Onlyadmin>
        ),
      },
      {
        path: "adminchats",
        element: (
          <Onlyadmin>
            <Adminchats permission={false} />
          </Onlyadmin>
        ),
      },
      { path: "adminpermission", element: <Adminpermission /> },
      {
        path: "createchat",
        element: (
          <Onlyadmin>
            <Addchat edite={false} />
          </Onlyadmin>
        ),
      },
      {
        path: "editeusers",
        element: (
          <Onlyadmin>
            <Addchat edite={true} />
          </Onlyadmin>
        ),
      },
      {
        path: "adduser",
        element: (
          <Onlyadmin>
            <Adduser />
          </Onlyadmin>
        ),
      },
      {
        path: "chat",
        element: (
          <Onlyadmin>
            <Thechat />
          </Onlyadmin>
        ),
      },
      {
        path: "finishedchats",
        element: (
          <Onlyadmin>
            <Finishedchats />
          </Onlyadmin>
        ),
      },
      {
        path: "chatpermission",
        element: (
          <Onlyadmin>
            <Chatpermission />
          </Onlyadmin>
        ),
      },
    ],
  },
]);
function App() {
  const [isTokenFound, setTokenFound] = useState(false);
  // getToken(setTokenFound);
  React.useEffect(() => {
    // if (isLogged) {
      getTokenB(setTokenFound);
      if (isTokenFound) {
        // sendToken(isTokenFound);
      }
    // }
  }, [isTokenFound]);
  const [notification, setNotification] = useState({title: '', body: ''});
  // const [isTokenFound, setTokenFound] = useState(false);
  // getToken(setTokenFound);

  onMessageListener().then(payload => {
    // setShow(true);
    setNotification({title: payload.notification.title, body: payload.notification.body})
    console.log(payload);
  }).catch(err => console.log('failed: ', err));
  // const [isTokenFound, setTokenFound] = React.useState(false);

  return <RouterProvider router={router} />;
}

export default App;
